<script>
  import Datepicker from "svelte-calendar";
  import { onMount, createEventDispatcher, getContext } from "svelte";
  import { dateShort } from "../../utils/conv";
  import Validators from "../../utils/validators";
  import CustomIcon from "../CustomIcon.svelte";

  const oneYear = 1000 * 60 * 60 * 24 * 365;

  export let label;
  export let name;
  export let required = false;
  export let initialValue;
  export let reset = false;
  export let start = new Date(Date.now() - oneYear);
  export let end = new Date(Date.now() + oneYear);
  export let disabled = false;

  const dispatch = createEventDispatcher();
  const { form, onFormChange, onBlur } = getContext("form");

  let selectedDate;
  let dateChosen;
  let formattedSelected;
  let value = "";

  $: if (reset) {
    dateChosen = false;
    value = "";
  }

  $: onChange(dateChosen ? selectedDate : value);

  onMount(() => {
    value = initialValue || "";
  });

  function formatDate(value) {
    if (value) {
      const date = new Date(value);
      return dateShort(date);
    } else {
      return "";
    }
  }

  function onChange(e) {
    dispatch("onChange", e);

    onFormChange({ target: { name, value: e ?? "" } });
  }

  const _required =
    required || form?.[name]?.validators?.includes(Validators.required);
</script>

{#if label}
  <label
    for={name}
    class="justify-self-end block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2 w-full"
  >
    {label}
    {#if _required}
      <span class="text-red-500">*</span>
    {/if}
  </label>
{/if}
<div class={label ? "mt-1 sm:col-span-2 w-full" : "sm:col-span-2 w-full"}>
  {#if disabled}
    <input
      readonly
      value={dateChosen ? formattedSelected : formatDate(value)}
      type="text"
      class="block w-full h-12 bg-gray-200 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-field-border-gray rounded-md"
    />
  {:else}
    <Datepicker
      bind:formattedSelected
      bind:selected={selectedDate}
      bind:dateChosen
      {start}
      {end}
      style="width:100%;"
    >
      <input
        readonly
        value={dateChosen ? formattedSelected : formatDate(value)}
        type="text"
        class="block w-full h-12 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-field-border-gray rounded-md"
      />
      {#if dateChosen}
        <a
          class="border border-white border-opacity-0 absolute top-0 right-0 pr-1 -ml-7 h-12 flex items-center"
          href="/"
          on:click|preventDefault={(e) => {
            e.stopPropagation();
            dateChosen = false;
            value = "";
          }}
        >
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            class="inline-block	mx-auto h-9 w-5 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg> -->
          <CustomIcon
            name="close"
            width={18}
            height={18}
            color="rgba(51, 51, 51,0.5)"
          />
        </a>
      {:else}
        <span
          class="border border-white border-opacity-0 absolute top-0 right-0 pr-1 -ml-7 h-12 flex items-center"
        >
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            class="inline-block	mx-auto h-9 w-5 icon cursor-pointer icon-tabler icon-tabler-calendar-event"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" />
            <rect x="4" y="5" width="16" height="16" rx="2" />
            <line x1="16" y1="3" x2="16" y2="7" />
            <line x1="8" y1="3" x2="8" y2="7" />
            <line x1="4" y1="11" x2="20" y2="11" />
            <rect x="8" y="15" width="2" height="2" />
          </svg> -->
          <CustomIcon
            name="date"
            width="20"
            height="20"
            color="rgba(51, 51, 51,0.5)"
          />
        </span>
      {/if}
    </Datepicker>
  {/if}
  <input
    {name}
    type="text"
    value={dateChosen ? selectedDate?.toISOString() : value}
    class="invisible w-0 h-0 p-0 m-0 border-0 absolute"
    on:change={onBlur}
  />
</div>
